import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { Formik, Field, ErrorMessage } from 'formik';

import { userActions } from '../_actions';
import './login.css';
import validate from './validation/validate-yup';
import getValidationSchema from './validation/getValidationSchema-yup';

class LoginPage extends React.Component {
  constructor(props) {
    super(props);

    const { dispatch } = this.props;
    // reset login status
    dispatch(userActions.logout());

    this.state = {
      companyCode: '',
      userId: '',
      password: '',
      submitted: false
    };
  }

  handleChange = e => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

  handleSubmit = (data, setSubmitting) => {
    const { dispatch } = this.props;
    dispatch(userActions.login(data.companyCode, data.userId, data.password));
  };

  render() {
    const { loggingIn } = this.props;

    const initialValues = {
      companyCode: '',
      userId: '',
      password: ''
    };

    return (
      <Formik
        initialValues={initialValues}
        validate={validate(getValidationSchema)}
        onSubmit={(values, { setSubmitting }) => {
          setTimeout(() => {
            this.handleSubmit(values, setSubmitting);
          }, 400);
        }}
      >
        {({ values, handleChange, handleBlur, handleSubmit, isSubmitting }) => (
          <div className="container login">
            <div className="col-sm-6 col-sm-offset-3">
              {alert.message && (
                <div className={`alert ${alert.type}`}>{alert.message}</div>
              )}
              <div className="col-md-6 col-md-offset-3">
                <h2>CrystalPayroll API Login</h2>
                <form name="form" onSubmit={handleSubmit}>
                  <div className={'form-group'}>
                    <label htmlFor="companyCode">Company Code</label>
                    <Field
                      name="companyCode"
                      id="companyCode"
                      type="text"
                      placeholder="Company Code"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.companyCode}
                    />
                    <div className="errorMsg">
                      <ErrorMessage name="companyCode" />
                    </div>
                  </div>
                  <div className={'form-group'}>
                    <label htmlFor="userId">User Id</label>
                    <Field
                      name="userId"
                      id="userId"
                      type="text"
                      placeholder="User ID"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.userId}
                    />
                    <div className="errorMsg">
                      <ErrorMessage name="userId" />
                    </div>
                  </div>
                  <div className={'form-group'}>
                    <label htmlFor="password">Password</label>
                    <Field
                      placeholder="Password"
                      type="password"
                      name="password"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.password}
                    />
                    <div className="errorMsg">
                      <ErrorMessage name="password" />
                    </div>
                  </div>
                  <div className="form-group">
                    {/* <Button type="submit" color="black" fluid size="large">
                      Login
                    </Button> */}

                    <button type="submit" className="btn btn-primary ">
                      Login
                    </button>

                    {loggingIn && (
                      <img src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
                    )}
                    <Link to="/register" className="btn btn-link">
                      New to us?{' '}
                      <span style={{ fontWeight: 'bold' }}>Register</span>
                    </Link>
                  </div>
                </form>
              </div>
            </div>
          </div>
        )}
      </Formik>
    );
  }
}

function mapStateToProps(state) {
  const { loggingIn } = state.authentication;
  return {
    loggingIn
  };
}

// function mapStateToProps(state) {
//     const { alert } = state;
//     return {
//         alert
//     };
// }
const connectedLoginPage = connect(mapStateToProps)(LoginPage);
export { connectedLoginPage as LoginPage };
